export default __webpack_public_path__ + "static/media/ic_alert_success.f48cb3fb.svg";